/** @jsxImportSource @emotion/react */
import { EuiButton, EuiModal } from "@inscopix/ideas-eui";
import { useDataTableContext } from "../store/DataTableProvider";
import { gql } from "@apollo/client";
import { useDataTableUpgradeButtonQuery } from "graphql/_Types";
import { useState } from "react";
import { ModalCreateAnalysisTable } from "../modals/ModalCreateColumn/ModalCreateAnalysisTable";
import { css } from "@emotion/react";

gql`
  query DataTableUpgradeButton($toolVersionId: Int!) {
    toolVersion: toolVersionById(id: $toolVersionId) {
      id
      tool: toolByToolId {
        id
        toolVersions: toolVersionsByToolId(orderBy: CREATED_ASC, last: 1) {
          nodes {
            id
          }
        }
      }
    }
  }
`;

export const DataTableButtonUpgrade = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const toolVersionId = useDataTableContext((s) => {
    const table = s.tables.find((table) => table.id === s.selectedTableId);
    return table?.toolVersion?.id;
  });

  // Fetch the latest tool version
  const { data } = useDataTableUpgradeButtonQuery({
    fetchPolicy: "cache-first",
    variables: { toolVersionId: toolVersionId ?? -1 },
    skip: toolVersionId === undefined,
  });

  const latestToolVersionId =
    data?.toolVersion?.tool?.toolVersions.nodes[0]?.id;

  // Render nothing unless there is a new tool version
  if (
    toolVersionId === undefined ||
    latestToolVersionId === undefined ||
    latestToolVersionId === toolVersionId
  ) {
    return null;
  }

  return (
    <>
      {isModalOpen && (
        <EuiModal
          onClose={() => setIsModalOpen(false)}
          css={css`
            width: 900px;
            max-width: 900px;
          `}
        >
          <ModalCreateAnalysisTable onClose={() => setIsModalOpen(false)} />
        </EuiModal>
      )}

      <EuiButton
        size="s"
        iconType="sortUp"
        onClick={() => setIsModalOpen(true)}
      >
        New version available
      </EuiButton>
    </>
  );
};
